import styles from "./MyEntriesInContest.module.css";
import useProfileGallery from "../../hooks/useProfileGallery";
import { useUserAuth } from "../../context/UserAuthContext";
import { getSingleProfieFile } from "../../context/apiCalls/apiCalls";
import Context from "../../context/Context";
import progressStar from "../../assests/progressStar.svg";
import Play from "../../assests/play.svg";

import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react";
import ProfilePopup from "../Profile/ProfilePopup";
import axios from "axios";
import ProgressPopup from "../ProgressPopup/ProgressPopup";

function MyEntriesInContest({
  campaignId,
  contestId,
  organiserId,
  contestDetails,
}) {
  const { verifyUser, userIdToken, details } = useContext(Context);
  const [pageNumber, setPageNumber] = useState(1);
  const { currentUser } = useUserAuth();
  const token = userIdToken || currentUser?.accessToken;
  const [showPreview, setShowPreview] = useState(false);
  const [singleFileDetails, setSingleFileDetails] = useState({});
  const [singleFileLoading, setSingleFileLoading] = useState(false);
  const [profileContent, setProfileContent] = useState([]);
  const [dataloading, setDataLoading] = useState(false);
  const [showProgress, setShowProgress] = useState(false);
  const [progressData, setProgressData] = useState({});

  useEffect(() => {
    verifyUser();
  }, []);
  useEffect(() => {
    if (contestId) {
      getMyEntries();
    }
  }, [contestId]);
  const getCampaignProgress = async (orgId, campaignId) => {
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_PARTICIPANT_PROGRESS}/${orgId}/${campaignId}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    let result = await axios(config);
    setProgressData(result?.data?.data);
  };
  //   const { dataloading, error, profileContent, hasMore } = useProfileGallery(
  //     pageNumber,
  //     token
  //   );

  //   const observer = useRef();
  //   const lastElementRef = useCallback(
  //     (node) => {
  //       if (dataloading) return;
  //       if (observer.current) observer.current.disconnect();
  //       observer.current = new IntersectionObserver((entries) => {
  //         if (entries[0].isIntersecting && hasMore) {
  //           setPageNumber((prevPageNumber) => prevPageNumber + 1);
  //         }
  //       });
  //       if (node) observer.current.observe(node);
  //     },
  //     [dataloading, hasMore]
  //   );
  const getMyEntries = async () => {
    setDataLoading(true);
    try {
      let config = {
        method: "GET",
        url: `${process.env.REACT_APP_GET_MYENTRIES}?type=myEntries&orgId=${organiserId}&campaignId=${campaignId}&contestId=${contestId}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      let result = await axios(config);
      setDataLoading(false);
      setProfileContent(result?.data?.data);
    } catch (error) {
      console.log(error.message);
      setDataLoading(false);
    }
  };
  const handleFileClick = async (obj) => {
    setSingleFileLoading(true);
    setSingleFileDetails([]);
    setShowPreview(true);
    const data = await getSingleProfieFile(
      obj.campaignId,
      obj.contestId,
      obj.videoId,
      token,
      obj.orgId
    );
    setSingleFileDetails(data);
    setSingleFileLoading(false);
  };
  return (
    <>
      {profileContent?.length > 0 && (
        <>
          <div className="flex justify-between items-center w-full z-1 relative pr-[20px]">
            <div className={styles.entry}>
              <p className="relative z-[1] mt-[10px]">My Entry</p>
            </div>
            {currentUser && contestDetails?.contestType?.startsWith("QUIZ") && (
              <button
                className="bg-white text-black px-[16px] py-[8px] text-small-bold rounded-[50px] flex items-center gap-[5px]"
                onClick={() => setShowProgress(true)}
              >
                <img src={progressStar} className="w-[15px] h-[15px]" />
                Show Progress
              </button>
            )}
          </div>
          <div className={styles.grid}>
            {profileContent && !dataloading && profileContent.length === 0 && (
              <div className="w-[100%] h-[70vh] flex flex-col items-center justify-center text-[#787878]">
                <span className="text-[17px] font-semibold">Profile empty</span>
                <span className="text-[14px] font-medium mt-[10px] text-center">
                  All the profile entries will be
                  <br /> displayed here.
                </span>
              </div>
            )}
            <div className={styles.pureGrid}>
              {profileContent?.map((obj, indexnumber) => {
                return (
                  <>
                    <div
                      onClick={() => handleFileClick(obj)}
                      className="rounded-[6px]"
                    >
                      <div className="relative">
                        <img
                          className={styles.gridingg}
                          src={
                            obj.thumbnailUrl
                              ? obj.thumbnailUrl
                              : `${
                                  obj?.fileUrls &&
                                  obj?.fileUrls[0]?.fileType === "image"
                                    ? obj?.fileUrls[0]?.fileUrl
                                    : details?.defaultThumbnail
                                }`
                          }
                          alt=""
                        />
                        {obj?.fileType === "video" && (
                          <img className={styles.playbtn} src={Play} alt="" />
                        )}
                        {obj?.status == "EDITED" && (
                          <div className={styles.filter}>
                            <p className="text-smallest3 text-center">
                              Under Review
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
          {showPreview && (
            <ProfilePopup
              setShowPreview={setShowPreview}
              singleFileDetails={singleFileDetails}
              token={token}
              profileContent={profileContent}
              singleFileLoading={singleFileLoading}
              setSingleFileDetails={setSingleFileDetails}
            />
          )}
          {showProgress && (
            <ProgressPopup
              setPopup={setShowProgress}
              data={progressData}
              getProgress={getCampaignProgress}
            />
          )}
        </>
      )}
    </>
  );
}

export default MyEntriesInContest;
